export enum OrderStatus {
  Backorder = 'backorder',
  Closed = 'closed',
  Error = 'error',
  Hold = 'hold',
  InProgress = 'in progress',
  NotSubmitted = 'not_submitted',
  Open = 'open',
  Retry = 'retry',
  Submitted = 'submitted',
  Submitting = 'submitting',
  Delivered = 'delivered',
  Invoiced = 'invoiced',
  PartiallyShipped = 'Partially shipped',
  PartiallyInvoiced = 'Partially invoiced',
}
